import { render } from "./OfficialDashboard.vue?vue&type=template&id=83ee7426&scoped=true"
import script from "./OfficialDashboard.vue?vue&type=script&lang=js"
export * from "./OfficialDashboard.vue?vue&type=script&lang=js"

import "./officialDashboard.css?vue&type=style&index=0&id=83ee7426&scoped=true&lang=css&external"
import "@/routes/tournament/tournamentCompetition.css?vue&type=style&index=1&id=83ee7426&scoped=true&lang=css&external"
import "@/routes/tournament/fanbase.css?vue&type=style&index=2&id=83ee7426&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ee7426"]])

export default __exports__